import axiosPost from "./axiosPost";

export const RNHComponenteSecundarioUpd = async (credentials, data) => {
    const body = {
        service: "RNHComponenteSecundarioUpd",
        params: {
            rnhComponenteSecundarioId: data?.id,
            rnhComponenteSecundarioCod: data?.cod,
            rnhComponenteSecundarioNombre: data?.name,
            rnhComponenteSecundarioDescripcion: data?.desc,
            rnhComponenteSecundarioVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
